var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"partnershipMobileCardsContainer"},_vm._l((_vm.partnerTableDataMap),function(partner,index){return _c('PartnershipMobileCard',{key:index,staticClass:"mb-4",attrs:{"index":index,"partner":partner}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }